import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as subscriptionActions} from '../../actions/subscriptionActions';
import { actions as accountActions } from '../../actions/accountActions';
import { Link } from 'react-router-dom';
import Card from '../Common/Card';
import Button from '../Common/Button';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';

export class Subscriptions extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            subscriptionId: "",
            subscriptions: [],
            isLoading: false
        };
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });
            const response = await this.props.subscriptionActions.listSubscriptions();
            if (response.type === types.LIST_SUBSCRIPTIONS_SUCCESS) {
                if (response.payload.length > 0) {
                    this.setState({ 
                        subscriptions: response.payload, 
                        subscriptionId: this.props.user.currentSubscriptionId || response.payload[0].id 
                    });
                } else {
                    Notification("error", "Error", "Unexpected results when loading subscriptions");
                }
            } else if (response.type === types.LIST_SUBSCRIPTIONS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onSubscriptionChange = (id) => {

        const newSub = this.state.subscriptions.find(x => x.id == id);
        this.props.accountActions.setCurrentSubscription(newSub.id, newSub.name, null, null);
        this.setState({ subscriptionId: id });
    }


    render() {
        return (
            <Card title="Subscription Profile">
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="row">
                        <div className="col-sm-12 col-md-9">
                            <div>
                                <MultiSelectBox 
                                    name="subs" 
                                    label="Subscriptions" 
                                    options={this.state.subscriptions} 
                                    idField="id" 
                                    valueField="name" 
                                    onChange={this.onSubscriptionChange} 
                                    defaultValue={null} 
                                    selectedValues={this.state.subscriptionId.toString()}
                                    isMulti={false}
                                />
                            </div>
                        </div>
                        <div className="subscription-buttons col-sm-12 col-md-3">
                            <div className="btn-group me-2">
                                <Link to={{ pathname: '/subscription/' + this.state.subscriptionId }}><Button type="button" bootstrapClass="" text="Edit" iconName="pencil-alt" /></Link>
                            </div>
                            <div className="btn-group me-2">
                                <Link to="/subscription"><Button type="button" bootstrapClass="" text="Add" iconName="plus-square" /></Link>
                            </div>
                            <div className="btn-group me-2">
                                <Link to={'/subscription/config/' + this.state.subscriptionId}><Button type="button" bootstrapClass="" text="Edit Configuration" iconName="cog" /></Link>
                            </div>
                            <div className="btn-group me-2">
                                <Link to={'/subscription/users/' + this.state.subscriptionId}><Button type="button" bootstrapClass="" text="Edit Users" iconName="user" /></Link>
                            </div>
                            <div className="btn-group me-2">
                                <Link to={'/subscription/' + this.state.subscriptionId + '/locations'}>
                                    <Button type="button" bootstrapClass="" text="Locations List" iconName="map-marker-alt"></Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Card>
        )
    }
}

Subscriptions.propTypes = {
    user: PropTypes.object,
    subscriptionActions: PropTypes.object.isRequired,
    accountActions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        subscriptionActions: bindActionCreators(subscriptionActions, dispatch),
        accountActions: bindActionCreators(accountActions, dispatch)
    };
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Subscriptions);
